import { apiSlice } from "@app/api/apiSlice";

export const shippingChargeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllStatic: builder.mutation({
      query: () => `static/admin/location/all`,
    }),
    loadAllShippingCharge: builder.mutation({
      query: (query) => `shipping-charge?${query}`,
    }),
    addEditShippingCharge: builder.mutation({
      query: (data) => ({
        url: `shipping-charge`,
        method: "POST",
        body: data,
      }),
    }),
    loadOneShippingCharge: builder.mutation({
      query: (id) => `shipping-charge/${id}`,
    }),
    deleteShippingCharge: builder.mutation({
      query: (id) => ({
        url: `shipping-charge/${id}`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoadAllStaticMutation,
  useLoadAllShippingChargeMutation,
  useLoadOneShippingChargeMutation,
  useAddEditShippingChargeMutation,
  useDeleteShippingChargeMutation,
} = shippingChargeApiSlice;
